import { render, staticRenderFns } from "./PopupImageList.vue?vue&type=template&id=24cbbe0f&scoped=true"
import script from "./PopupImageList.vue?vue&type=script&lang=js"
export * from "./PopupImageList.vue?vue&type=script&lang=js"
import style0 from "./PopupImageList.vue?vue&type=style&index=0&id=24cbbe0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cbbe0f",
  null
  
)

export default component.exports